/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * React context for chapter content tree state.
 *
 * @file ChapterContentContext.jsx
 * @author Gladson Samuel S
 * @since 2.0.0
 */

import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const ChapterContentContext = createContext(null);

export const ChapterContentProvider = ({ value, children }) => (
  <ChapterContentContext.Provider value={value}>
    {children}
  </ChapterContentContext.Provider>
);

ChapterContentProvider.propTypes = {
  value: PropTypes.shape({
    nodes: PropTypes.array,
    questionCounts: PropTypes.array,
    textInfo: PropTypes.object,
    restrictAssigned: PropTypes.bool,
    variant: PropTypes.oneOf(['picker', 'schedule']),
    onScheduleMenuAction: PropTypes.func,
    onAddToDate: PropTypes.func,
    style: PropTypes.object
  }).isRequired,
  children: PropTypes.node.isRequired
};

export const useChapterContent = () => {
  const context = useContext(ChapterContentContext);

  if (!context) {
    throw new Error('useChapterContent must be used within ChapterContentProvider');
  }

  return context;
};
